import { resolvePublicPath } from './path-utils.js';

export async function loadSupabaseConfig() {
  try {
    const configPath = resolvePublicPath('/supabase/config.js');
    return await import(configPath);
  } catch (error) {
    console.warn('supabase/config.js not found, using example placeholder.', error);
    const examplePath = resolvePublicPath('/supabase/config.example.js');
    return await import(examplePath);
  }
}
